import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppBubble from "@/components/conversion/WhatsAppBubble";
import ScrollAppointmentButton from "@/components/conversion/ScrollAppointmentButton";
import CalendlyModal from "@/components/conversion/CalendlyModal";
import SmartFormModal from "@/components/conversion/SmartFormModal";
import CookieBanner from "@/components/conversion/CookieBanner";
import { LangProvider } from "@/context/LanguageContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <LangProvider>
      <ScrollToTop />
      <Header />
      <main id="main">
        <Outlet />
      </main>
      <div data-hide-appointment>
        <Footer />
      </div>
      <WhatsAppBubble />
      <ScrollAppointmentButton />
      <CalendlyModal />
      <SmartFormModal />
      <CookieBanner />
    </LangProvider>
  );
}
